var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,29h6V23.562a2,2,0,0,0-1.515-1.941l-5.833-1.458a1,1,0,0,1-.747-.829l-.412-2.881A6,6,0,0,0,26,11V8.252A6.166,6.166,0,0,0,20.185,2,5.977,5.977,0,0,0,17,2.8",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-color": "color-2",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.549,23.586l-4.925-1.408a1,1,0,0,1-.716-.82l-.415-2.905S17.219,18.734,19,17a10.229,10.229,0,0,1-2-6.738,6.185,6.185,0,0,0-5.761-6.257A6,6,0,0,0,5,10a10.452,10.452,0,0,1-2,7c1.781,1.734,5.507,1.453,5.507,1.453l-.415,2.905a1,1,0,0,1-.716.82L2.451,23.586A2,2,0,0,0,1,25.509V29H21V25.509A2,2,0,0,0,19.549,23.586Z",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableUsers);
export default __webpack_public_path__ + "static/media/Table-Users.a94a494b9c63d90bfa4926db8a05dfc3.svg";
export { ForwardRef as ReactComponent };